export default "__VITE_ASSET__Dxc5bwxs__"